import { EBAY, ETSY, FAIRE, SHOPIFY } from '@/constants/channels';
import { ATTRIBUTE } from '@/constants/attributes';
import { EVENT } from '@/constants/tracking';

export const AI_ATTRIBUTE = {
  COMPLEMENT_PHOTO: 'complement_photo',
};

export const AI_OPERATION = {
  ADD_MAXIMUM: 'add_maximum',
  GENERATE: 'generate',
  IMPROVE: 'improve_writing',
  REPLACE: 'replace_all',
};

export const AI_OPERATION_LABEL = {
  [AI_OPERATION.ADD_MAXIMUM]: 'Add maximum',
  [AI_OPERATION.GENERATE]: 'Optimize',
  [AI_OPERATION.IMPROVE]: 'Improve writing',
  [AI_OPERATION.REPLACE]: 'Replace all',
};

export const AI_OPERATIONS = {
  [EBAY]: {
    [ATTRIBUTE.DESCRIPTION]: [
      AI_OPERATION.IMPROVE,
    ],
    [ATTRIBUTE.TITLE]: [
      AI_OPERATION.IMPROVE,
    ],
  },
  [ETSY]: {
    [ATTRIBUTE.DESCRIPTION]: [
      AI_OPERATION.IMPROVE,
    ],
    [ATTRIBUTE.TAGS]: [
      AI_OPERATION.REPLACE,
      AI_OPERATION.ADD_MAXIMUM,
    ],
    [ATTRIBUTE.TITLE]: [
      AI_OPERATION.IMPROVE,
    ],
  },
  [FAIRE]: {
    [ATTRIBUTE.DESCRIPTION]: [
      AI_OPERATION.IMPROVE,
    ],
    [ATTRIBUTE.TITLE]: [
      AI_OPERATION.IMPROVE,
    ],
  },
  [SHOPIFY]: {
    [ATTRIBUTE.DESCRIPTION]: [
      AI_OPERATION.IMPROVE,
    ],
    [ATTRIBUTE.META_DESCRIPTION]: [
      AI_OPERATION.GENERATE,
    ],
    [ATTRIBUTE.PAGE_TITLE]: [
      AI_OPERATION.GENERATE,
    ],
    [ATTRIBUTE.SEO]: [
      AI_OPERATION.GENERATE,
    ],
    [ATTRIBUTE.TITLE]: [
      AI_OPERATION.IMPROVE,
    ],
  },
};

export const OPTIMIZE_OPERATION = {
  [EBAY]: {
    [ATTRIBUTE.DESCRIPTION]: AI_OPERATION.IMPROVE,
    [ATTRIBUTE.TITLE]: AI_OPERATION.IMPROVE,
  },
  [ETSY]: {
    [ATTRIBUTE.DESCRIPTION]: AI_OPERATION.IMPROVE,
    [ATTRIBUTE.TAGS]: AI_OPERATION.REPLACE,
    [ATTRIBUTE.TITLE]: AI_OPERATION.IMPROVE,
  },
  [FAIRE]: {
    [ATTRIBUTE.DESCRIPTION]: AI_OPERATION.IMPROVE,
    [ATTRIBUTE.TITLE]: AI_OPERATION.IMPROVE,
  },
  [SHOPIFY]: {
    [ATTRIBUTE.DESCRIPTION]: AI_OPERATION.IMPROVE,
    [ATTRIBUTE.META_DESCRIPTION]: AI_OPERATION.GENERATE,
    [ATTRIBUTE.PAGE_TITLE]: AI_OPERATION.GENERATE,
    [ATTRIBUTE.TITLE]: AI_OPERATION.IMPROVE,
  },
};

export const ATTRIBUTE_TO_DESTINATION = {
  [ATTRIBUTE.META_DESCRIPTION]: 'seo_description',
  [ATTRIBUTE.PAGE_TITLE]: 'seo_title',
};

export const DESTINATION_TO_ATTRIBUTE = {
  seo_description: ATTRIBUTE.META_DESCRIPTION,
  seo_title: ATTRIBUTE.PAGE_TITLE,
};

export const PHOTO_TYPE = {
  CUSTOM: 'custom',
  DETAIL: 'detail',
  LIFESTYLE: 'lifestyle',
  STAGED: 'staged',
  STUDIO: 'studio',
};

export const PHOTO_TYPE_LABEL = {
  [PHOTO_TYPE.CUSTOM]: 'Custom',
  [PHOTO_TYPE.DETAIL]: 'Detail',
  [PHOTO_TYPE.LIFESTYLE]: 'Lifestyle',
  [PHOTO_TYPE.STAGED]: 'Staged',
  [PHOTO_TYPE.STUDIO]: 'Studio',
};

export const PHOTO_TYPES = [
  PHOTO_TYPE.STUDIO,
  PHOTO_TYPE.STAGED,
  PHOTO_TYPE.LIFESTYLE,
  PHOTO_TYPE.DETAIL,
  PHOTO_TYPE.CUSTOM,
];

export const PHOTO_TYPE_TOOLTIP = {
  [PHOTO_TYPE.DETAIL]: 'Close-up photos, highlighting key details or presenting the product at alternative angles to provide a complete look at your products',
  [PHOTO_TYPE.LIFESTYLE]: 'Realistic photos, showing products being used in real-world scenarios by relevant customers to show people, animals, or others engaging with your products',
  [PHOTO_TYPE.STAGED]: 'Editorial photos, placing products in a tasteful staged environment with props, accessories, and other relevant objects to create a stylish setting',
  [PHOTO_TYPE.STUDIO]: 'Simplistic photos, featuring products on a plain background with professional lighting and appropriate shadows to highlight exactly what you’re selling',
};

export const AI_ATTRIBUTE_EVENT = {
  [ATTRIBUTE.DESCRIPTION]: {
    KEEP: EVENT.AI.DESCRIPTION.KEEP,
    OPTIMIZE: EVENT.AI.DESCRIPTION.OPTIMIZE,
    RETRY: EVENT.AI.DESCRIPTION.RETRY,
    REVERT: EVENT.AI.DESCRIPTION.REVERT,
  },
  [ATTRIBUTE.META_DESCRIPTION]: {
    KEEP: EVENT.AI.META_DESCRIPTION.KEEP,
    OPTIMIZE: EVENT.AI.META_DESCRIPTION.OPTIMIZE,
    RETRY: EVENT.AI.META_DESCRIPTION.RETRY,
    REVERT: EVENT.AI.META_DESCRIPTION.REVERT,
  },
  [ATTRIBUTE.PAGE_TITLE]: {
    KEEP: EVENT.AI.PAGE_TITLE.KEEP,
    OPTIMIZE: EVENT.AI.PAGE_TITLE.OPTIMIZE,
    RETRY: EVENT.AI.PAGE_TITLE.RETRY,
    REVERT: EVENT.AI.PAGE_TITLE.REVERT,
  },
  [ATTRIBUTE.PHOTOS]: {
    GENERATE: EVENT.AI.PHOTOS.GENERATE,
    KEEP: EVENT.AI.PHOTOS.KEEP,
    OPTIMIZE: EVENT.AI.PHOTOS.OPTIMIZE,
    RETRY: EVENT.AI.PHOTOS.RETRY,
    REVERT: EVENT.AI.PHOTOS.REVERT,
    SELECT: EVENT.AI.PHOTOS.SELECT,
  },
  [ATTRIBUTE.TAGS]: {
    KEEP: EVENT.AI.TAGS.KEEP,
    OPTIMIZE: EVENT.AI.TAGS.OPTIMIZE,
    RETRY: EVENT.AI.TAGS.RETRY,
    REVERT: EVENT.AI.TAGS.REVERT,
    [AI_OPERATION.ADD_MAXIMUM]: EVENT.AI.TAGS.ADD_MAXIMUM,
    [AI_OPERATION.REPLACE]: EVENT.AI.TAGS.REPLACE_ALL,
  },
  [ATTRIBUTE.TITLE]: {
    KEEP: EVENT.AI.TITLE.KEEP,
    OPTIMIZE: EVENT.AI.TITLE.OPTIMIZE,
    RETRY: EVENT.AI.TITLE.RETRY,
    REVERT: EVENT.AI.TITLE.REVERT,
  },
};
